<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <div class="grid_table" v-if="$store.state.userDetail.manage_type_product_create == 1">
        <v-form ref="form" @submit.prevent="createProduct_type">
          <div class="margin_right">
            <v-card>
              <div class="pl-4 pt-4">
                <span style="font-size: 24px">เพิ่มประเภทสินค้า</span>
              </div>
              <div class="pa-2">
                <div class="mt-2">
                  <div class="mb-1">
                    ชื่อประเภทสินค้า
                  </div>
                  <v-text-field color="#86bc3a" label="ชื่อประเภทสินค้า" v-model="add_typeProduct.product_name" :rules="[v => !!v || 'กรุณากรอกชื่อประเภทสินค้า']" required hide-details="auto" outlined></v-text-field>
                </div>
                <div class="mt-2">
                  <div class="mb-1">
                    สถานะ
                  </div>
                  <v-select clearable color="#86bc3a" :items="type_status" item-text="name" item-value="id" label="สถานะ" :rules="[v => !!v || 'กรุณาเลือกสถานะ']" required v-model="add_typeProduct.status_product" hide-details="auto" outlined/>
                </div>
                <div class="text-center mt-3 mb-2">
                  <v-btn large type="submit" class="white--text grad-success-bg btn_size">บันทึกข้อมูล</v-btn>
                </div>
              </div>
            </v-card>
          </div>
        </v-form>
        <div class="margin_left">
          <v-card>
            <div class="pa-4">
              <v-card-title>
                <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="headers" :items="dataProductType" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
                <template v-slot:item="dataDetail" class="grid_btn">
                  <tr>
                    <td>{{ dataDetail.item.name }}</td>
                    <td>{{ dataDetail.item.product_type_status_show }}</td>
                    <td class="pa-3" v-if="$store.state.userDetail.manage_type_product_edit == 1">
                      <v-btn small height="42" @click="getEdit(dataDetail.item.id)" class="grad-warning-bg white--text mr-1 mb-1" title="แก้ไข">
                        <v-icon>mdi-note-edit-outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
            <v-dialog v-model="edit_typeProduct" max-width="900">
              <v-card>
                <v-form ref="add_form" @submit.prevent="updateEdit">
                  <v-card-title>
                    แก้ไข้ประเภทสินค้า
                  </v-card-title>

                  <v-card-text>
                    <div>
                      <div class="grid_half">
                        <div class="mt-2 ml-1 mr-1">
                          <div class="mb-1">
                            ชื่อประเภทสินค้า
                          </div>
                          <v-text-field color="#86bc3a" label="ชื่อประเภทสินค้า" v-model="update_typeProduct.product_name" hide-details="auto" required outlined></v-text-field>
                        </div>
                        <div class="mt-2 ml-1 mr-1">
                          <div class="mb-1">
                            สถานะ
                          </div>
                          <v-select clearable color="#86bc3a" :items="type_status" item-text="name" item-value="id" label="สถานะ" v-model="update_typeProduct.status_product" hide-details="auto" required outlined/>
                        </div>
                      </div>
                    </div>
                  </v-card-text>
                  <v-spacer></v-spacer>
                  <div class="text-center pa-4">
                    <v-btn large class="grad-success-bg white--text mr-3 btn_size" type="submit">
                      บันทึก
                    </v-btn>
                    <v-btn large class="grad-danger-bg white--text btn_size" type="button" @click="edit_typeProduct = false">
                      ยกเลิก
                    </v-btn>
                  </div>
                </v-form>
              </v-card>
            </v-dialog>
          </v-card>
        </div>
      </div>
      <div class="grid_table_2" v-if="$store.state.userDetail.manage_type_product_create !== 1">
        <div class="margin_left">
          <v-card>
            <div class="pa-4">
              <v-card-title>
                <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="headers" :items="dataProductType" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
                <template v-slot:item="dataDetail" class="grid_btn">
                  <tr>
                    <td>{{ dataDetail.item.name }}</td>
                    <td>{{ dataDetail.item.product_type_status_show }}</td>
                    <td class="pa-3" v-if="$store.state.userDetail.manage_type_product_edit == 1">
                      <v-btn small height="42" @click="getEdit(dataDetail.item.id)" class="grad-warning-bg white--text mr-1 mb-1" title="แก้ไข">
                        <v-icon>mdi-note-edit-outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
            <v-dialog v-model="edit_typeProduct" max-width="900">
              <v-card>
                <v-form ref="add_form" @submit.prevent="updateEdit">
                  <v-card-title>
                    แก้ไข้ประเภทสินค้า
                  </v-card-title>

                  <v-card-text>
                    <div>
                      <div class="grid_half">
                        <div class="mt-2 ml-1 mr-1">
                          <div class="mb-1">
                            ชื่อประเภทสินค้า
                          </div>
                          <v-text-field color="#86bc3a" label="ชื่อประเภทสินค้า" :rules="[v => !!v || 'กรุณากรอกชื่อประเภทสินค้า']" v-model="update_typeProduct.product_name" hide-details="auto" required outlined></v-text-field>
                        </div>
                        <div class="mt-2 ml-1 mr-1">
                          <div class="mb-1">
                            สถานะ
                          </div>
                          <v-select color="#86bc3a" :items="type_status" item-text="name" item-value="id" label="สถานะ" :rules="[v => !!v || 'กรุณาเลือกสถานะ']" v-model="update_typeProduct.status_product" hide-details="auto" required outlined/>
                        </div>
                      </div>
                    </div>
                  </v-card-text>
                  <v-spacer></v-spacer>
                  <div class="text-center pa-4">
                    <v-btn large class="grad-success-bg white--text mr-3 btn_size" type="submit">
                      บันทึก
                    </v-btn>
                    <v-btn large class="grad-danger-bg white--text btn_size" type="button" @click="edit_typeProduct = false">
                      ยกเลิก
                    </v-btn>
                  </div>
                </v-form>
              </v-card>
            </v-dialog>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP } from '@/axios.js'
import Swal from "sweetalert2";
export default {
  name: "Product_Setting",
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  data() {
    return {
      loading_page: false,
      search: null,
      edit_typeProduct: false,
      focus_name: false,
      focus_status: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      type_status: [
        {id: 0, name:"สินค้า"},
        {id: 1, name:"ยา"},
        {id: 2, name:"คลินิก"},
        {id: 3, name:"สินค้าของแถมไม่สามารถขายได้"},
      ],
      add_typeProduct: {
        product_name: null,
        status_product: null,
      },
      update_typeProduct: {
        id_product: null,
        product_name: null,
        status_product: null,
      },
      headers: [],
      data: [
        {
          id: 1,
          product_type: 'กล่อง',
          status_product: 'คลีนิก'
        },
      ],
      dataProductType: [],
    }
  },
  methods: {

    checkLoading() {
      this.loading_page = true
      HTTP.post('/products/producttype/all')
          .then((res) => {
            if (res.data.success === true){
              this.loading_page = false
              this.dataProductType = res.data.object;
            }
          })
    },
    header() {
      if (this.$store.state.userDetail.manage_type_product_edit == 1) {
        this.headers = [
          {
            text: 'ชื่อประเภทสินค้า',
            value: 'name',
            fixed: true,
            width: '200px'
          },
          {
            text: 'สถานะ',
            value: 'product_type_status_show',
            fixed: true,
            width: '100px'
          },
          {
            text: 'เมนูจัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '150px'
          },
        ]
        return this.headers
      }
      else if (this.$store.state.userDetail.manage_type_product_edit !== 1) {
        this.headers = [
          // {
          //   text: 'ลำดับ',
          //   value: 'id',
          //   fixed: true,
          //   width: '100px'
          // },
          {
            text: 'ชื่อประเภทสินค้า',
            value: 'name',
            fixed: true,
            width: '200px'
          },
          {
            text: 'สถานะ',
            value: 'product_type_status_show',
            fixed: true,
            width: '100px'
          },
        ]
        return this.headers
      }
    },
    showAlert() {
      // Use sweetalert2
      Swal.fire({
        title: 'แก้ไขข้อมูลเรียบร้อย',
        icon: 'success',
        confirmButtonText: 'ตกลง'
      }).then(() => {
        this.edit_typeProduct = false;
        this.getProductType();
      })
    },
    createProduct_type() {
      if (this.add_typeProduct.product_name !== null && this.add_typeProduct.status_product !== null && this.add_typeProduct.product_name !== '' && this.add_typeProduct.status_product !== '') {
        HTTP.post('/products/producttype/create', {
          name: this.add_typeProduct.product_name,
          product_type_status: this.add_typeProduct.status_product
        }).then((res) => {
          if (res.data.success === true){
            this.add_typeProduct.product_name = null;
            this.add_typeProduct.status_product = null;
            Swal.fire('บันทึกข้อมูลเรียบร้อย', '', 'success')
            this.getProductType();
            this.$refs.form.resetValidation();
          } else {
            Swal.fire({
              title: 'ไม่สามารถดำเนินการได้ !',
              text: res.data.message,
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            })
          }
        })
      }
      else {
        Swal.fire({
          title: 'ไม่สามารถดำเนินการได้ !',
          text: 'กรุณากรอกข้อมูล !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then(() => {
          this.$refs.form.validate()
        })
      }
    },
    getProductType() {
      HTTP.post('/products/producttype/all')
          .then((res) => {
            if (res.data.success === true){
              this.dataProductType = res.data.object;
            }
          })
    },
    getEdit(id) {
      this.edit_typeProduct = true;
      HTTP.post('/products/producttype/show', {
        id: id
      }).then((res) => {
        if (res.data.success === true){
          this.update_typeProduct.id_product = res.data.object.id;
          this.update_typeProduct.product_name = res.data.object.name;
          const status = this.type_status.find((details) => {
            return details.id == res.data.object.product_type_status;
          });
          this.update_typeProduct.status_product = status.id;
        }
      })
    },
    updateEdit() {
      if (this.update_typeProduct.product_name !== null && this.update_typeProduct.status_product !== null && this.update_typeProduct.product_name !== '' && this.update_typeProduct.status_product !== '') {
        HTTP.post('/products/producttype/edit', {
          id: this.update_typeProduct.id_product,
          name: this.update_typeProduct.product_name,
          product_type_status: this.update_typeProduct.status_product,
        }).then((res) => {
          if (res.data.success === true){
            this.showAlert();
          } else {
            Swal.fire({
              title: 'ไม่สามารถดำเนินการได้ !',
              text: res.data.message,
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            })
          }
        })
      }
      else {
        Swal.fire({
          title: 'ไม่สามารถดำเนินการได้ !',
          text: 'กรุณากรอกข้อมูล !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then(() => {
          this.$refs.add_form.validate()
        })
      }
    },
  },
  beforeMount() {
    // this.checkLogIn()
    this.checkLoading()
  },
  mounted() {
    this.header()
  }
}
</script>

<style scoped>
.grid_table_2 {
  display: grid;
  grid-template-columns: 100%;
}
.grid_table {
  display: grid;
  grid-template-columns: 40% 60%;
}
.btn_size {
  font-size: 18px;
}
.margin_right {
  margin-right: 40px;
}
.margin_left {
  margin-right: 10px;
}
@media only screen and (max-width: 1100px) {
  .grid_table {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 20px 0;
  }
  .margin_right {
    margin-right: 0;
  }
  .margin_left {
    margin-right: 0;
  }
}
</style>
